import React, { useState } from 'react';
import { Menu, X, Languages } from 'lucide-react';
import { Button } from '../components/ui/button';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import AboutSection from '../components/AboutSection';
import FreeLegalAidSection from '../components/FreeLegalAidSection';
import TeamSection from '../components/TeamSection';
import PracticeAreas from '../components/PracticeAreas';
import AchievementsSection from '../components/AchievementsSection';
import ConsultationForm from '../components/ConsultationForm';
import PaymentSection from '../components/PaymentSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { translations } from '../mock';

const Home = () => {
  const [language, setLanguage] = useState('en');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white shadow-sm z-50">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/3rxsnv1c_1000782169.png" 
                alt="Pathan & Associates Logo" 
                className="h-12 w-auto"
              />
            </div>

            <nav className="hidden md:flex items-center space-x-6">
              <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_home}</button>
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_about}</button>
              <button onClick={() => scrollToSection('team')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_team || 'Team'}</button>
              <button onClick={() => scrollToSection('practice')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_practice}</button>
              <button onClick={() => scrollToSection('achievements')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_achievements || 'Achievements'}</button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-900 transition-colors">{t.nav_contact}</button>
              <Button onClick={toggleLanguage} variant="outline" size="sm" className="flex items-center space-x-1">
                <Languages className="h-4 w-4" />
                <span>{language === 'en' ? 'हिं' : 'EN'}</span>
              </Button>
              <Button onClick={() => scrollToSection('consultation')} className="bg-amber-600 hover:bg-amber-700">{t.nav_consultation}</Button>
            </nav>

            <div className="flex md:hidden items-center space-x-2">
              <Button onClick={toggleLanguage} variant="outline" size="sm">
                <Languages className="h-4 w-4" />
              </Button>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-700">
                {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          {mobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 space-y-3 border-t pt-4">
              <button onClick={() => scrollToSection('home')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_home}</button>
              <button onClick={() => scrollToSection('about')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_about}</button>
              <button onClick={() => scrollToSection('team')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_team || 'Team'}</button>
              <button onClick={() => scrollToSection('practice')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_practice}</button>
              <button onClick={() => scrollToSection('achievements')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_achievements || 'Achievements'}</button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-700 hover:text-blue-900">{t.nav_contact}</button>
              <Button onClick={() => scrollToSection('consultation')} className="w-full bg-amber-600 hover:bg-amber-700">{t.nav_consultation}</Button>
            </nav>
          )}
        </div>
      </header>

      <HeroSection t={t} scrollToSection={scrollToSection} />
      <StatsSection t={t} />
      <AboutSection t={t} />
      <FreeLegalAidSection t={t} />
      <TeamSection t={t} language={language} />
      <PracticeAreas t={t} language={language} />
      <AchievementsSection t={t} />
      <ConsultationForm t={t} />
      <PaymentSection t={t} />
      <ContactSection t={t} />
      <Footer t={t} scrollToSection={scrollToSection} />
      
      {/* WhatsApp Floating Button */}
      <WhatsAppButton />
    </div>
  );
};

export default Home;
